// Copyright 2019 Sorama B.V.

import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export abstract class IWorkflowModuleCatalog {
    /**
     *
     * @param type Module type to filter for. If none, all modules are returned
     */
    public abstract getWorkflowModules(type?: WorkflowModuleType | WorkflowModuleType[]): IWorkflowModuleConfig[];
}
